import React from "react";
import { motion } from "framer-motion";
import { FaHeartbeat, FaLaptopMedical, FaUserMd, FaNotesMedical, FaMicroscope, FaDna, FaCapsules, FaRobot } from "react-icons/fa";
import Img1 from '../../assests/service/bginovation.jpg';

export default function HealthcareInnovations() {
    return (
        <motion.div
            className="bg-gray-200 min-h-screen text-gray-800"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            {/* Hero Section */}
            <div className="relative w-full h-[500px] flex flex-col items-center justify-center text-white text-center px-6 bg-cover bg-center" style={{ backgroundImage: `url(${Img1})` }}>
            <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)] backdrop-blur-sm"></div>
                <motion.h1
                    className="text-5xl font-extrabold drop-shadow-lg"
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                >
                    <span className="text-white drop-shadow-md text-[30px] shadow-black">Innovations in Healthcare</span>
                </motion.h1>
                <p className="text-lg mt-4 max-w-3xl text-white drop-shadow-md text-explosion">
                    Exploring the latest advancements in medical technology, AI, and patient care solutions.
                </p>
            </div>

            {/* Innovations Section */}
            {/* <div className=" bg-gradient-to-l from-[#78ffa5] to-[#03ab3b] max-w-full mx-auto py-16 px-6"> */}
            <div className=" bg-white max-w-full mx-auto py-16 px-6">
                <motion.div
                    className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-center"
                    initial="hidden"
                    whileInView="visible"
                    variants={containerVariants}
                >
                    <InnovationCard title="AI in Healthcare" icon={<FaLaptopMedical />} description="Revolutionizing diagnostics and treatment with artificial intelligence." />
                    <InnovationCard title="Telemedicine" icon={<FaUserMd />} description="Remote consultations and digital healthcare access." />
                    <InnovationCard title="Wearable Health Tech" icon={<FaHeartbeat />} description="Real-time health monitoring with smart devices." />
                    <InnovationCard title="Electronic Health Records" icon={<FaNotesMedical />} description="Secure and streamlined patient data management." />
                    <InnovationCard title="Precision Medicine" icon={<FaDna />} description="Personalized treatments based on genetic analysis." />
                    <InnovationCard title="Robotic Surgery" icon={<FaRobot />} description="Minimally invasive procedures with robotic assistance." />
                    <InnovationCard title="Pharmaceutical Innovations" icon={<FaCapsules />} description="Cutting-edge drug development and delivery." />
                    <InnovationCard title="Medical Imaging" icon={<FaMicroscope />} description="Advanced imaging techniques for better diagnosis." />
                </motion.div>
            </div>
        </motion.div>
        
    );
}

const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { staggerChildren: 0.4, duration: 1.05 } }
};

const InnovationCard = ({ title, icon, description }) => (
    <motion.div
        className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 p-6 shadow-lg rounded-xl transform hover:scale-105 transition-all duration-300 border-t-4 border-[#2a627a]"
        variants={containerVariants}
    >
        <div className="text-[#2a627a] text-5xl mb-3">{icon}</div>
        <h3 className="text-lg font-bold">{title}</h3>
        <p className="text-gray-600 text-sm mt-2">{description}</p>
    </motion.div>
);